import { isSsr, useIsomorphicLayoutEffect, usePageScroll } from '@lemonade-hq/cdk';
import useOptionalTween from './useOptionalTween';
import useTrackPad from './useTrackPad';

const DEFAULT_MOUSE_SMOOTH_SCROLL_MULTIPLIER = 10000;

interface Props {
  strength?: number;
  initialRelativeScroll?: number;
  ssrHelp?: boolean;
}

interface SmoothScrollReturnValue extends ReturnType<typeof usePageScroll> {
  smoothRelativeScroll: number;
}

// TODO: monolu
export function getRelativeScroll(): number {
  const absoluteScrollTop = window.scrollY !== undefined ? window.scrollY : document.documentElement.scrollTop;
  const contentHeight = document.documentElement.scrollHeight;
  const windowHeight = window.innerHeight;
  const relativeScroll = absoluteScrollTop / (contentHeight - windowHeight);
  return relativeScroll;
}

export default function useSmoothScroll({
  initialRelativeScroll,
  ssrHelp,
  strength,
}: Props = {}): SmoothScrollReturnValue {
  const { isTrackPad } = useTrackPad();
  const scrollProps = usePageScroll();
  const { relativeScroll: t } = scrollProps;

  // TODO: move to monolu under `usePageScroll`
  useIsomorphicLayoutEffect(() => {
    if (initialRelativeScroll != null) {
      const initialScroll = initialRelativeScroll * (document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo(0, initialScroll);
    }
  }, []);

  // this automatically scrolls the page by a pixel after a refresh, so the `t` value gets rehydrated (since there's no scroll value in SSR)
  useIsomorphicLayoutEffect(() => {
    if (ssrHelp) {
      window.scrollTo(0, window.scrollY - 1);
    }
  }, []);

  const smoothRelativeScroll = useOptionalTween(t, !isTrackPad, strength ?? DEFAULT_MOUSE_SMOOTH_SCROLL_MULTIPLIER);
  if (isSsr()) {
    return { smoothRelativeScroll: initialRelativeScroll ?? t, ...scrollProps };
  }

  return { smoothRelativeScroll, ...scrollProps };
}
